module.exports = __webpack_public_path__ + "media/entities/16-55d8dd64.png";